import React from 'react';
/*
    - ihoDesignSystem
*/
import { Box, Grid, Image, Typography } from '@iho-design-system/Loader';

/*
    - svg
*/
import BankSVG from '../../../assets/images/finance/bank.svg';
import ShapeSVG from '../../../assets/images/finance/shape.svg';

const Banner = ({ props }) => {
    /*
        -defaultData
    */
    const [bankAccount, setBankAccount] = React.useState([{}, {}, {}]);

    React.useEffect(() => {
        if (props.bankAccount.status === 200 && props.bankAccount.data.length > 0) {
            setBankAccount(props.bankAccount.data);
        } else {
            setBankAccount([{}, {}, {}]);
        }
    }, [props]);

    return (
        <React.Fragment>
            <Grid>
                <Grid.Wrapper>
                    <Grid.Item
                        size='col-12'>
                        <Box
                            className={`rounded-lg position-relative`}
                            ms={{
                                width: '100%',
                                height: '170px',
                                backgroundColor: '#E3F3FF',
                                border: '1px solid #6EDDE7'
                            }}>
                            <Box
                                className='w-100 h-100 position-absolute'>
                                <Image
                                    className={`h-100`}
                                    src={ShapeSVG}
                                    alt='shape' />
                            </Box>
                            <Box
                                className={`position-absolute left-xxl bottom-xxl`}
                                ms={{
                                    width: '200px',
                                    '@media(max-width:576px)': {
                                        width: '160px',
                                        left: '0.75rem'
                                    }
                                }}>
                                <Image
                                    src={BankSVG}
                                    alt='banner-wallet' />
                            </Box>
                            <Box
                                className={`position-absolute transform-vertical-center right-xxl`}
                                ms={{
                                    '@media(max-width:576px)': {
                                        right: '0.75rem'
                                    }
                                }}>
                                {bankAccount[0].BankName !== undefined && bankAccount[0].CardNumber !== undefined && bankAccount[0].Sheba !== undefined &&
                                    <Typography
                                        className='d-block'>
                                         شماره حساب اصلی من
                                    </Typography>
                                }
                                <Typography
                                    className='d-block text-danger'
                                    component='h4'>
                                    {bankAccount[0].BankName !== undefined && bankAccount[0].BankName}
                                </Typography>
                                <Typography
                                    className='d-block text-primary'
                                    component='h3'>
                                    {bankAccount[0].CardNumber !== undefined && bankAccount[0].CardNumber.toString().replace(/\B(?=(\d{4})+(?!\d))/g, '-')}
                                </Typography>
                                <Typography
                                    className='d-block text-bold'
                                    component='small'>
                                    {bankAccount[0].Sheba !== undefined && `IR-` + bankAccount[0].Sheba}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid.Item>
                </Grid.Wrapper>
            </Grid>
        </React.Fragment>
    );

}

export default Banner;